import { combineReducers } from 'redux';
import UserReducer from './user.reducer';
import QrReducer from './qr.reducer';

export default combineReducers({
    UserReducer,
    QrReducer
});



// WEBPACK FOOTER //
// ./src/store/index.js